export enum Keys {
  USER_FORM = 'RBI:USER_FORM',
  HAS_SHOWN_STORE_CHANGE_DIALOG = 'RBI:HAS_SHOWN_STORE_CHANGE_DIALOG',
  REDEMPTION_START_TIME = 'RBI:REDEMPTION_START_TIME',
  MPARTICLE_SESSION = 'RBI:MPARTICLE_SESSION',
  FROM_PAYMENT = 'RBI:FROM_PAYMENT',
}
